import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

export type PurchaseState = null | "inProgress" | "completed";

export type PurchaseStateContextValue = {
  purchaseState: PurchaseState;
  updatePurchaseState: Dispatch<SetStateAction<PurchaseState>>;
};

export const PurchaseStateContext =
  createContext<PurchaseStateContextValue | null>(null);

export const usePurchaseStateContext = () => {
  const context = useContext(PurchaseStateContext);
  if (!context) {
    throw new Error(
      "usePurchaseStateContext must be used within a PurchaseStateContextProvider",
    );
  }
  return context;
};
